export const selectIncome = state => state.income;
